import { DashboardService } from '@/services';

export default {
    namespaced: true,
    state: {
        dateFormatMap: {},
        dimensionOptionsMap: {},
    },
    mutations: {
        setDateFormatMap(state, data) {
            state.dateFormatMap = Object.freeze(data);
        },
        setDimensionOptionsMap(state, data) {
            state.dimensionOptionsMap = Object.freeze(data);
        },
    },
    actions: {
        async getAutoDateFormat(
            { commit, state },
            { assetId, dateFieldDimension }
        ) {
            const dateFormatMap = state.dateFormatMap;
            const PATH = [assetId, dateFieldDimension];

            // dateFormat from state
            if (R.hasPath(PATH, dateFormatMap)) {
                return R.path(PATH, dateFormatMap);
            }

            //  dateFormat from api
            const autoDateFormat = await DashboardService.getAutoDateFormat({
                assetId,
                dateFieldDimension,
            })
                .then(({ data: _data = '' }) => {
                    const data = _data === 'undefined' ? '' : _data;

                    const updatedMap = R.assocPath(PATH, data, dateFormatMap);
                    commit('setDateFormatMap', updatedMap);

                    return data;
                })
                .catch(() => {
                    return '';
                });

            return autoDateFormat;
        },
        async getDimensionOptions({ commit, state }, { widgetDimension }) {
            const dimensionOptionsMap = state.dimensionOptionsMap;

            // dimensionOptions from state
            if (R.has(widgetDimension, dimensionOptionsMap)) {
                return R.prop(widgetDimension, dimensionOptionsMap);
            }

            // dimensionOptions from api
            const dimensionOptions =
                await DashboardService.getDimensionsByWidgetDimension({
                    widgetDimension,
                })
                    .then(({ data = [] }) => {
                        const updatedMap = R.assoc(
                            widgetDimension,
                            data,
                            dimensionOptionsMap
                        );
                        commit('setDimensionOptionsMap', updatedMap);

                        return data;
                    })
                    .catch(() => {
                        return [];
                    });

            return dimensionOptions;
        },
    },
};
